

const SupportCard=({url,title})=>
{
   
    return(
        <div style={{boxShadow:"0px 3.31104px 26.4883px rgba(38, 22, 87, 0.1)",fontFamily:"Inter"}} className="text-[#574B3D] flex flex-col items-center text-center gap-[17px] sm:pt-[50px] sm:pb-[20px] lg:py-[40px] px-[15px] relative  z-10 lg:mb-[0px]">
            <div className="z-10 rounded-full border-4 border-white p-[20px] bg-[#FFF3E5] absolute top-[-35px] z-10">
                <img className="w-[30px] h-[30px] z-10" src={url}></img>
            </div>
            <p className="text-[16px] font-[600] leading-[26px]">{title}</p>
            
        </div>
    )
}
export default SupportCard